/**
 * Indicates the type of transfer transaction.
 * tag: 2439
 * @readonly
 * @enum {number} (int)
 */
export enum TransferTransType {
  /** New */
  New = 0,
  /** Replace */
  Replace = 1,
  /** Cancel */
  Cancel = 2,
}
